// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"49":"3c51521f","78":"f01abd8a","116":"c8f350e7","152":"3c51521f","347":"9a493276","421":"8bbb22f1","756":"71422225"}[chunkId] + ".chunk.css";
};